import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import BeatLoader from 'react-spinners/BeatLoader';
import CSVReader from '~/../components/communities_manage/components/csv_reader';
import CSVTable from './csv_table';
import {
  CSVFormAdapter,
  downloadCSVTemplate,
} from '../../../shared/utils/csv_helpers.js';
import { sendImportedInvites } from './../../../shared/utils/api';

const Importer = ({ data, setModalOpen, setModalTimerId, customMessage }) => {
  const [message, setMessage] = useState(customMessage);
  const [feedback, setFeedback] = useState({});
  const feedbackTimer = useRef(null);

  const [isLoading, setLoading] = useState(false);
  const [CSVData, setCSVData] = useState([]);
  const [CSVFile, setCSVFile] = useState([]);
  const [malformedCSV, setMalformedCSV] = useState(false);

  useEffect(() => {
    if (CSVData.length > 0) {
      CSVFormAdapter(
        CSVData,
        setCSVFile,
        data.slug,
        handleFeedback,
        setMalformedCSV
      );
    }
  }, [CSVData]);

  const handleInviteSend = () => {
    if (isEmpty(CSVData)) {
      handleFeedback('danger', ['Please import a CSV to send invites'], 'csv');
      return;
    }

    if (isEmpty(message)) {
      handleFeedback('danger', ['Please enter a valid message'], 'message');
      return;
    }

    if (malformedCSV) {
      handleFeedback(
        'danger',
        ['Please check that your CSV file is properly formatted'],
        'invite'
      );
      return;
    }

    const body = { ...data, message };

    if (!isEmpty(feedback) && feedback.type !== 'warning') {
      handleFeedback(feedback);
      return;
    }

    sendImportedInvites(body, CSVFile, handleSuccess, handleFailure);
    setLoading(true);
  };

  const handleSuccess = (res) => {
    setLoading(false);
    setCSVData([]);
    handleFeedback('green', ['Your invites are on the way!'], 'invite');
    setTimeout(() => setModalOpen(false), 2000);
  };

  const handleFailure = ({ message }) => {
    setLoading(false);
    handleFeedback('red', message, 'invite');
  };

  const handleFeedback = (type, msg, field = 'csv') => {
    setFeedback({ type, msg, field });
    feedbackTimer.current = setTimeout(() => setFeedback({}), 7000);
    setModalTimerId(feedbackTimer.current);
  };

  const handleFeedbackDisplay = (field, classes = '') => {
    const messages = feedback.msg?.map((msg, idx) => (
      <span
        key={`${msg}-idx`}
        className={`${feedback.type} mt-5 block feedback-container ${classes}`}
      >
        {msg}
      </span>
    ));

    return (
      feedback.field === field && !isEmpty(feedback) ? (
        messages
      ) : (
        <span className={`mt-5 block feedback-container ${classes}`}></span>
      )
    );
  }

  const renderCsvInput = () => {
    if (CSVData.length > 0 && !malformedCSV) {
      return (
        <div className='clear'>
          <CSVTable
            headers={CSVData[0]}
            data={CSVData.slice(1)}
            classList={'table-container mb-6 col-8 col-md-12'}
          />
        </div>
      );
    }

    return (
      <CSVReader
        setCSVData={setCSVData}
        resetInputEmails={() => null}
        setCSVFile={setCSVFile}
      />
    );
  };

  return (
    <div>
      <p className='t5 w1 mb-10'>
        We require your CSV’s header row to contain columns for ‘First Name’,
        ‘Last Name’, & ‘Email’. Click {' '}
        <span
          className='download-template-btn t5 w1'
          onClick={downloadCSVTemplate}
        >
          here
        </span>{' '}
        to download an example template.
        Additional columns in the example are optional.
      </p>
      {renderCsvInput()}
      {handleFeedbackDisplay('csv')}
      <label className='mt-30 w1'>Add a message</label>
      <textarea
        className='form-control mt-5'
        placeholder='Let those you invite know why you are inviting them to this community'
        rows='5'
        onChange={(e) => setMessage(e.target.value)}
        defaultValue={message}
      />
      {handleFeedbackDisplay('message')}
      <div className='mt-10 mb-60'>
        <button
          className='btn btn-main btn-send-invites right mt-20'
          onClick={handleInviteSend}
          disabled={isLoading}
        >
          {isLoading ? (
            <BeatLoader
              color='#3d898b'
              speedMultiplier={0.5}
              className='invite-loading'
            />
          ) : (
            'Send Invites'
          )}
        </button>
      </div>
      {handleFeedbackDisplay('invite', 'modal-btn-feedback')}
    </div>
  );
};

Importer.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Importer;
